module.exports = __webpack_public_path__ + "img/procom.813c25a5.png";